/**
 * Date utils
 */
export default {
  /**
   * Get padded month
   * @param   {Date}  date
   * @return  {String}
   */
  getPaddedMonth (date) {
    return ('0' + (date.getMonth() + 1)).slice(-2)
  },
  getPaddedDay (date) {
    return ('0' + (date.getDate())).slice(-2)
  },

  /**
   * Localization for date parts
   */
  local: {
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    daysOfWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    fullDaysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    fullMonthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },

  /**
   * https://weeknumber.net/how-to/javascript
   * @param   {Date}  date
   * @return  {Number}
   */
  getWeekNumber (_date) {
    // We don't want to mutate the original date
    let date = new Date(_date.getFullYear(), _date.getMonth(), _date.getDate())
    date.setHours(0, 0, 0, 0)
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7)
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4)
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7)
  },

  /**
   * Get how many weeks are in a month
   * @param   {Date}  date
   * @return  {Number}
   */
  getWeeksInMonth (date) {
    var firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)

    var used = firstOfMonth.getDay() + lastOfMonth.getDate()

    return Math.ceil(used / 7)
  },

  /**
   * Get number of days in a month
   * @param   {Date}  date
   * @return  {Number}
   */
  getDaysInMonth (date) {
    var d = new Date(date.getFullYear(), date.getMonth() + 1, 0)

    return d.getDate()
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st'
      case 2:
      case 22:
        return 'nd'
      case 3:
      case 23:
        return 'rd'
      default:
        return 'th'
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/util/date.js